import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

class ViewSwitch extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        const renderSwitches = ()=>{
            return this.props.options.map((opt)=>{
                return <Button size="small"  inverted={(this.props.value!=opt.value)} primary onClick={()=>{this.props.onChange(opt.value)}}>{opt.text}</Button>
            })
        }

        return (
            <div className="ViewSwitch" style={{marginTop:10, marginBottom:10, textAlign:'right'}}>
                {renderSwitches()}
            </div>
        )
    }
}

ViewSwitch.propTypes = {
    
}

export default ViewSwitch;


// WEBPACK FOOTER //
// ./src/components/common/ViewSwitch.js